import { render, staticRenderFns } from "./CompareCardsBar.vue?vue&type=template&id=4b88f329&scoped=true&"
import script from "./CompareCardsBar.vue?vue&type=script&lang=js&"
export * from "./CompareCardsBar.vue?vue&type=script&lang=js&"
import style0 from "./CompareCardsBar.vue?vue&type=style&index=0&id=4b88f329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88f329",
  null
  
)

export default component.exports